import * as i0 from '@angular/core';
import { InjectionToken, inject, isDevMode, Injectable, NgModule, APP_INITIALIZER } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { coerceArray } from '@rxap/utilities';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

function DefaultIconSvgFilePath() {
    return 'mdi.svg';
}
const RXAP_ICON_ASSET_PATH = new InjectionToken('rxap/icon/asset-path', {
    providedIn: 'root',
    factory: DefaultIconSvgFilePath,
});

/**
 * @deprecated use the ProvideIconAssetPath function in the app.config.ts file
 */
class IconLoaderService {
    constructor() {
        this.matIconRegistry = inject(MatIconRegistry);
        this.domSanitizer = inject(DomSanitizer);
        this.pathList = inject(RXAP_ICON_ASSET_PATH);
    }
    load() {
        const pathList = coerceArray(this.pathList);
        if (isDevMode()) {
            console.debug(`load icon sets from path [ ${pathList.join('/')} ]`);
        }
        for (const path of pathList) {
            try {
                this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl(path));
            }
            catch (e) {
                console.error(`Could not load icon set from path ${path}`, e.message);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: IconLoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: IconLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: IconLoaderService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * @deprecated use the ProvideIconAssetPath function in the app.config.ts file
 */
class IconModule {
    constructor(iconLoaderService) {
        iconLoaderService.load();
    }
    static forRoot(path = DefaultIconSvgFilePath()) {
        return {
            ngModule: IconModule,
            providers: [
                {
                    provide: RXAP_ICON_ASSET_PATH,
                    useValue: path,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: IconModule, deps: [{ token: IconLoaderService }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.1", ngImport: i0, type: IconModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: IconModule, providers: [provideHttpClient(withInterceptorsFromDi())] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{ imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] }]
        }], ctorParameters: () => [{ type: IconLoaderService }] });

function LoadIconSetsFactory(matIconRegistry, domSanitizer, pathList) {
    return () => {
        pathList = coerceArray(pathList);
        if (isDevMode()) {
            console.debug(`load icon sets from path [${pathList.join(', ')}]`);
        }
        for (const path of pathList) {
            try {
                matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl(path));
            }
            catch (e) {
                console.error(`Could not load icon set from path ${path}`, e.message);
            }
        }
    };
}
function ProvideIconAssetPath(pathList = [
    'mdi.svg',
    'custom.svg',
]) {
    return [
        {
            provide: APP_INITIALIZER,
            multi: true,
            useFactory: LoadIconSetsFactory,
            deps: [MatIconRegistry, DomSanitizer, RXAP_ICON_ASSET_PATH],
        },
        {
            provide: RXAP_ICON_ASSET_PATH,
            useValue: pathList,
        },
    ];
}

// region 
// endregion

/**
 * Generated bundle index. Do not edit.
 */

export { DefaultIconSvgFilePath, IconLoaderService, IconModule, LoadIconSetsFactory, ProvideIconAssetPath, RXAP_ICON_ASSET_PATH };
